import React, { useRef } from "react";
import { useModalA11y } from "../hooks/useModalA11y";

export default function ProWelcomeModal({ isOpen, onClose }) {
  const modalRef = useRef(null);
  const closeRef = useRef(null);
  useModalA11y({
    isOpen,
    onClose,
    containerRef: modalRef,
    initialFocusRef: closeRef
  });

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="glass modal-content"
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-label="Welcome to Pro"
      >
        <div className="header-flex">
          <h2 style={{ margin: 0 }}>⭐ Welcome to Pro</h2>
          <button
            className="btn-nav"
            onClick={onClose}
            style={{ border: "none", fontSize: "1.2rem" }}
            aria-label="Close welcome modal"
            ref={closeRef}
          >
            ✕
          </button>
        </div>
        <div className="modal-scroll-body">
          <section>
            <p>Thanks for upgrading! Pro unlocks everything added in v6.x:</p>
            <div style={{ display: "grid", gap: "6px", margin: "10px 0" }}>
              <div>• Templates (including multi-chore templates)</div>
              <div>• Recurring exceptions + Skip Today</div>
              <div>• Due times with reminders</div>
              <div>• Reward shop + redemptions</div>
              <div>• Approval power tools</div>
              <div>• Weekly recap + analytics</div>
              <div>• Big Tap Mode</div>
              <div>• Power Hour + bonus points</div>
              <div>• Family goals + challenges</div>
              <div>• Audit log</div>
              <div>• Calendar sync</div>
              <div>• Template marketplace</div>
              <div>• AI routine builder</div>
            </div>
            <p>Check <strong>PLANS.md</strong> for the full breakdown.</p>
          </section>
        </div>
        <button className="btn-nav success-btn" style={{ width: "100%", marginTop: "20px", padding: "12px" }} onClick={onClose}>
          Let’s Go
        </button>
      </div>
    </div>
  );
}
